import { useQuery } from '@tanstack/react-query';
import { useProductsApi } from './use-products-api';

const QK_SEARCH_PRODUCTS = (query: string | null | undefined) =>
  ['products', 'search', query] as const;

// Nullable so callers can wire conditional state without breaking rules-of-hooks.
export function useSearchProducts(query: string | null | undefined) {
  const { productsApi } = useProductsApi();

  return useQuery({
    queryKey: QK_SEARCH_PRODUCTS(query),
    queryFn: () => {
      if (!query) {
        throw new Error('Search query is required');
      }
      return productsApi.search(query);
    },
    enabled: !!query,
  });
}
